import { TOASTR_SHOW, TOASTR_HIDE_ALL } from './constants';

export function showSuccessToastr(message) {
  return {
    type: TOASTR_SHOW,
    messageType: 'success',
    message,
    show: true,
  };
}

export function showErrorToastr(message) {
  return {
    type: TOASTR_SHOW,
    messageType: 'error',
    message,
    show: true,
  };
}

export function hideToastr() {
  return {
    type: TOASTR_HIDE_ALL,
    show: false,
  };
}



// WEBPACK FOOTER //
// ./app/containers/Toastr/actions.js